module.exports = __webpack_public_path__ + "img/icons_user_support.8fb65696.svg";